module.exports = __webpack_public_path__ + "static/media/640.f61caca4.png";